import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AppQRCodeModal } from '@/modules/Onboarding/components/ConnectEcoSystem/AppQRCodeModal';
import { GooglePlayButton } from '@/modules/Onboarding/components/ConnectEcoSystem/GooglePlayButton';
import { QrCodeButton } from '@/modules/Onboarding/components/ConnectEcoSystem/QrCodeButton';
import { NextImage, Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import AydiGreenLogo from '~/images/Ecosystem/AydiGreenLogo.svg';
import FieldAppAR from '~/images/Ecosystem/FieldAppAR.png';
import FieldAppEN from '~/images/Ecosystem/FieldAppEn.png';
import FieldAppES from '~/images/Ecosystem/FieldAppES.png';
import FieldAppFR from '~/images/Ecosystem/FieldAppFR.png';
import FieldAppKA from '~/images/Ecosystem/FieldAppKA.png';

const FieldApp: React.FC<{
  flex: 'flex-col' | 'flex-row' | 'flex-row-reverse' | 'flex-col-reverse';
}> = ({ flex }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('onboarding');
  const { openModal } = useModal();
  const handleShowQrCode = () => {
    openModal(<AppQRCodeModal type='field' />, {
      containerClassName: 'max-w-sm',
    });
  };

  return (
    <div className={clsx(flex, 'mt-24 flex w-full items-center gap-16 px-24')}>
      <NextImage
        alt={t('field-app')}
        src={
          language === 'ar'
            ? FieldAppAR
            : language === 'es'
            ? FieldAppES
            : language === 'fr'
            ? FieldAppFR
            : language === 'ka'
            ? FieldAppKA
            : FieldAppEN
        }
        height={230}
        width={270}
      />
      <div
        className={clsx(
          'flex flex-col gap-16',
          flex === 'flex-row-reverse' || flex === 'flex-row'
            ? 'w-2/3'
            : 'w-full'
        )}
      >
        <div className='flex w-full gap-8'>
          <span className='text-40'>
            <AydiGreenLogo />
          </span>
          <div className='flex flex-col'>
            <Typography weight='semiBold' variant='body1'>
              {t('field-app')}
            </Typography>
            <Typography variant='body1' className='text-surface-10'>
              {t('field-app-description')}
            </Typography>
          </div>
        </div>
        <div className='flex w-full gap-2'>
          <GooglePlayButton url='https://play.google.com/store/apps/details?id=com.aydi.field.app' />
          <QrCodeButton color='green' onClick={handleShowQrCode} />
        </div>
      </div>
    </div>
  );
};

export { FieldApp };
